import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getCils = async (formType) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/cil/data/${formType}`, {
        headers: { Authorization: token }
    });
};

export const getCil = async (id) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/cil/cil/${id}`, {
        headers: { Authorization: token }
    });
};

export const acceptCil = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/cil/accept/${id}`, formDate, {
        headers: { Authorization: token }
    });
};

export const pendingCil = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/cil/pending_cil/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const rejectCil = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/cil/reject/${id}`, formDate, {
        headers: { Authorization: token }
    });
};


export const hideCil = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/cil/hide/${id}`, formDate, {
        headers: { Authorization: token }
    });
};